import { render, staticRenderFns } from "./ViewComments.vue?vue&type=template&id=e89226e2&"
import script from "./ViewComments.vue?vue&type=script&lang=js&"
export * from "./ViewComments.vue?vue&type=script&lang=js&"
import style0 from "./ViewComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports